<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 600px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'PayProcessChartStat',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: {},
      option: {},
      errCode: {
        '-1': '非法参数',
        '-9': '支付失败',
        '-1002': 'Token过期',
        '-11001': '谷歌验签失败',
        '-11002': '苹果验签失败',
        '-11004': '超过购买上限',
        '-11005': '购买错误的商品类型',
        '-11006': '金币不足',
        '-11007': '未支持的商品',
        '-11008': 'ItemDelivery',
        '-11009': '已退款',
        '-11010': '无效状态',
        '-11012': '配置限制',
        '-1008': '次数不足',
        '-1003': '接口请求频率限制'
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: this.title
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        {
          type: 'value',
          axisLabel: {
            formatter: '{value}%' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    refresh(data) {
      this.initChart()
      const time = []
      const d = { 'create_order': [], 'order_pay': [], 'pay_status': [], 'order_ship': [], 'order_ship_status': [] }
      const legend = {
        'create_order': '创建订单',
        'order_pay': '调起支付',
        'pay_status': '支付成功',
        'order_ship': '请求发货',
        'order_ship_status': '发货成功'
      }
      for (const i in data) {
        const val = data[i]
        time.push(dateStrTodate(val.date))
        for (const k in val) {
          if (d[k] !== undefined) {
            d[k].push(val[k])
          }
        }
      }

      for (const i in d) {
        const val = d[i]
        this.option.legend.data.push(legend[i])
        const temp = {
          name: legend[i],
          data: val,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          },
          itemStyle: {
            // 设置柱子宽度
            barWidth: '50%'
          }
        }
        this.option.series.push(temp)
      }
      this.option.xAxis.data = time
      this.chart.setOption(this.option, true)
    },
    payFail(data, key) {
      this.initChart()
      const time = []
      const d = { }
      if (key === 'corder_ship_status_distribution') {
        const reasonObj = {}
        const reasonArr = []
        for (const i in data) {
          const val = data[i]
          for (const k in val[key]) {
            const v = val[key][k]
            if (reasonObj[v.reason] === undefined) {
              reasonObj[v.reason] = 1
              reasonArr.push(v.reason)
            }
          }
        }
        for (const i in data) {
          const val = data[i]
          const reason = val.corder_ship_status_distribution.map(item => item.reason)
          for (const k in reasonArr) {
            if (!reason.includes(reasonArr[k])) {
              val.corder_ship_status_distribution.push({ reason: reasonArr[k], count: 0 })
            }
          }
        }
      }
      for (const i in data) {
        const val = data[i]
        time.push(dateStrTodate(val.date))
        for (const k in val[key]) {
          const v = val[key][k]
          if (d[v.reason] === undefined) {
            d[v.reason] = []
          }
          d[v.reason].push(v.count)
        }
      }
      for (const i in d) {
        const val = d[i]
        let name = i
        if (key === 'corder_ship_status_distribution') {
          if (this.errCode[name]) {
            name = this.errCode[name]
          }
        }
        this.option.legend.data.push(name)
        const temp = {
          name: name,
          data: val,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          },
          itemStyle: {
            // 设置柱子宽度
            barWidth: '50%'
          }
        }
        this.option.series.push(temp)
      }
      this.option.xAxis.data = time
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
